import { originMeta } from "@/lib/screenBindings";

/** Iter 48 — Parser-proven / Manual pill. Manual bindings are never described as source-proven. */
export default function OriginBadge({ origin, inactive = false, testid, compact = false }) {
  const m = originMeta(origin);
  return (
    <span
      className="inline-flex items-center gap-1 ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap"
      style={{ background: m.bg, color: m.fg, borderColor: m.border, opacity: inactive ? 0.6 : 1 }}
      title={m.hint}
      data-testid={testid || `origin-badge-${origin}`}
      data-origin={origin}
      data-inactive={inactive ? "true" : "false"}
    >
      {m.label}{!compact && origin === "manual" && <span className="normal-case tracking-normal">· not parser-proven</span>}{inactive && <span className="normal-case tracking-normal">· inactive</span>}
    </span>
  );
}
